import React from 'react';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import { useAppContext } from 'Context/ReactAppContext';
import { isFeatureFlipped } from 'Utils/feature-flipping/featureFlippingUtils';
import type { SeeMoreProps } from './SeeMoreEngine';
import { SeeMoreEngine } from './SeeMoreEngine';
export const SeeMore = (props: SeeMoreProps) => {
  const appContext = useAppContext();
  const { isDesktop } = useResponsive();
  const unfoldMobileContent = isFeatureFlipped(appContext)('unfoldMobileContent');
  return !isDesktop && unfoldMobileContent ? props.children : <SeeMoreEngine {...props} />;
};
